import {HexMath} from "../../HexMath";
import {SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {checkIfHexBlockedByEnemyUnit} from "../checkIfHexBlockedByEnemyUnit";

/**
 * Проверяет, есть ли смежный military_camp с указанным гексом
 * @param unitHexKey
 * @param player
 * @param {Object} hexes - Объект гексов
 * @param {Object} specialBuildings - Объект специальных строений
 * @param citiesCache
 * @param units
 * @param buildingsDamage
 * @returns {boolean} true, если есть смежный military_camp
 */
export const checkIfAdjacentToWorkingMilitaryCamp = (unitHexKey, player, hexes, specialBuildings, citiesCache, units, buildingsDamage) => {
  const [q, r] = unitHexKey.split(',').map(Number);
  const hexMath = new HexMath(30, 'flat');
  const neighbors = hexMath.getNeighborsFlatTop(q, r);

  for (const neighbor of neighbors) {
    const [q, r] = neighbor;
    const neighborKey = `${q},${r}`;
    // Проверяем, есть ли на соседнем гексе military_camp
    const specialBuilding = specialBuildings && specialBuildings[neighborKey];
    if (specialBuilding === SPECIAL_BUILDING_TOKENS.MILITARY_CAMP) {
      const isBlocked = checkIfHexBlockedByEnemyUnit(neighborKey, SPECIAL_BUILDING_TOKENS.MILITARY_CAMP, player.id, units, hexes, specialBuildings, buildingsDamage);
      return !isBlocked;
    }
  }

  return false;
};
